module.exports = __webpack_public_path__ + "img/santander.231d7d69.svg";